export const ResetLink = async (email, redirectUrl) => {
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  try {
    const response = await fetch(`${window.constants.api_url}/forgot-password`, {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify({ email, redirect_url: redirectUrl }),
      redirect: "follow",
    });
    return response.json();
  } catch (error) {
    console.error("Error:", error);
    return { code: "error", message: "An error occurred" };
  }
};

// Ask the server to send a one-time code (WhatsApp + email) for a password
// reset. identifier = email, username or phone.
export const requestPasswordOtp = async (identifier) => {
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  try {
    const response = await fetch(`${window.constants.api_url}/forgot-password/otp`, {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify({ identifier }),
      redirect: "follow",
    });
    return response.json();
  } catch (error) {
    console.error("Error:", error);
    return { code: "error", message: "An error occurred" };
  }
};

// Reset the password using the one-time code.
export const resetPasswordWithOtp = async (identifier, otp, password, passwordConfirmation) => {
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  try {
    const response = await fetch(`${window.constants.api_url}/reset-password/otp`, {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify({
        identifier,
        otp,
        password,
        password_confirmation: passwordConfirmation,
      }),
      redirect: "follow",
    });
    return response.json();
  } catch (error) {
    console.error("Error:", error);
    return { code: "error", message: "An error occurred" };
  }
};

export const newPassword = async (password, token) => {
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  try {
    const response = await fetch(`${window.constants.api_url}/set-new-password`, {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify({ token, password, password_confirmation: password }),
      redirect: "follow",
    });
    return response.json();
  } catch (error) {
    console.error("Error:", error);
    return { code: "error", message: "An error occurred" };
  }
};
